import { useEffect, useState } from 'react'
import { Button, Form, InputGroup } from 'react-bootstrap'
import './Home.scss'
import { hasValue } from '../../helpers'
import { useNavigate } from 'react-router-dom'
import { FaChevronRight, FaUsersGear } from 'react-icons/fa6'
import { FaSearch } from 'react-icons/fa'
import { IoDocumentText } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { CompanyCard, Footer, KonektoNavbar } from 'components'

export default function Home() {
  const navigate = useNavigate()
  const [searchQuery, setSearchQuery] = useState('')

  const homePageCompanies = useSelector(state =>
    Array.isArray(state.company?.homePageCompanies)
      ? state.company.homePageCompanies
      : [],
  )

  const onSearchSubmit = e => {
    e.preventDefault()
    if (hasValue(searchQuery)) {
      navigate(`/pretraga?q=${searchQuery}`)
    }
  }

  return (
    <div className="home">
      <KonektoNavbar />

      <div>
        <div className="container mt-5 px-5">
          <div className="row info">
            <div className="col-12 col-md-6 d-flex flex-column justify-content-center pe-md-5">
              <h1>
                Dobrodošli <br /> na Konekto
              </h1>
              <p>
                Konekto je mjesto gdje se susreću domaći proizvodi, zanati i
                usluge iz cijele Bosne i Hercegovine. Ovdje predstavljamo naš
                rad, našu pamet i ljude koji stoje iza svakog proizvoda i
                usluge. <br />
                Ako tražite pouzdane domaće proizvođače, majstore ili usluge –
                na pravom ste mjestu.
              </p>
            </div>

            <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-end">
              <Form onSubmit={onSearchSubmit}>
                <InputGroup className={`rounded-pill search-bar`}>
                  <Form.Control
                    type="text"
                    placeholder="Pretraga - Stolarija, varioc..."
                    className="rounded-pill"
                    aria-label="Search"
                    value={searchQuery}
                    onChange={e => {
                      setSearchQuery(e.target.value)
                    }}
                  />
                  <Button
                    onClick={onSearchSubmit}
                    variant="outline-secondary"
                    className="rounded-pill">
                    <FaSearch className="fs-5" />
                  </Button>
                </InputGroup>
              </Form>
              <button
                onClick={onSearchSubmit}
                className="btn btn-primary rounded-pill mt-3 fw-bold fs-5 search-button">
                Pretraži proizvode i usluge
              </button>
            </div>
          </div>
        </div>

        <div className="how-it-works mt-5 py-5">
          <div>
            <IoDocumentText />
            <h2>Zahtjevi i ponude</h2>
            <p>
              Kreirajte jedan zahtjev i dobijte više ponuda od verifikovanih
              firmi.
            </p>
            <ul>
              <li>Samo relevantne firme</li>
              <li>Vaši podaci su zaštićeni</li>
            </ul>

            <button
              onClick={() => navigate('/zahtjevi/kreiraj')}
              className="rounded-pill btn btn-primary">
              Pošalji zahtjev
            </button>
          </div>

          <div>
            <FaUsersGear className="mt-5 mt-md-0" />
            <h2>Kreirajte profil vaše firme</h2>
            <p>Profesionalno predstavite Vaš proizvod, zanat ili uslugu</p>
            <ul>
              <li>Lična podrška</li>
              <li>
                Pojavite se u rezultatima dnevnih pretraga naših korisnika
              </li>
            </ul>

            <button
              onClick={() => navigate('/moja-firma')}
              className="rounded-pill btn btn-primary">
              Kreiraj profil
            </button>
          </div>
        </div>

        <div className="mt-5 popular-companies">
          <div className="container pb-5">
            <div className="mb-5">
              <h4 className="section-header text-center">Izdvojene firme</h4>
            </div>

            <div className="row">
              {homePageCompanies.map((company, index) => {
                return (
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-4" key={index}>
                    <CompanyCard company={company} />
                  </div>
                )
              })}
            </div>

            <div
              onClick={() => navigate('/sve-firme')}
              className="section-link mt-2">
              <span>Vidi sve firme</span>
              <FaChevronRight />
            </div>

            <h2 className="section-header mt-5 mb-3">
              Registrujte se kao kupac
            </h2>
            <p className="fs-5">
              Lakše dođite do ljudi koji stoje iza kvalitetnih proizvoda i
              usluga.
            </p>
            <ul>
              <li className="mt-2">Pronađite ono što vam zaista treba</li>
              <li className="mt-2">Otkrijte pouzdane firme u vašem kraju</li>
              <li className="mt-2">Direktno kontaktirajte više ponuđača</li>
            </ul>

            <button
              onClick={() => navigate('/moja-firma')}
              className="rounded-pill btn btn-primary">
              Registracija
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}
